// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16hOH","title":"styles_title__DldMm"};